import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { Box, Stack, Typography } from '@mui/material';
import { KeyCap } from 'ui-kit';
import { BaseDialog } from '@/components/dialogs';
import { formatShortcutKey } from '@/utils/shortcutKey';
import { GENERAL_SHORTCUTS } from './shortcuts.ts';

const rowSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  minHeight: 44,
  px: 3,
  bgcolor: 'background.paper-elevation-4',
} as const;

// F is handled inside the market menu, so the app-wide hook doesn't bind it.
const rows = [
  ...GENERAL_SHORTCUTS,
  {
    key: 'f',
    label: msg({
      comment: 'Keyboard shortcut action: toggle the highlighted market as a favorite while the Markets menu is open',
      message: 'Favorite (in Markets)',
    }),
  },
];

/** Keyboard Shortcuts guide — opened from the footer "Shortcuts" button. Figma: Keyboard shortcuts, screen 3. */
export function KeyboardShortcutsDialog() {
  const { t } = useLingui();

  return (
    <BaseDialog
      dialogKey="keyboardShortcutsDialog"
      title={t({ comment: 'Dialog title', message: 'Keyboard Shortcuts' })}
      maxWidth="xs"
    >
      <Stack component="ul" spacing={0.5} sx={{ listStyle: 'none', m: 0, p: 0, py: 1 }}>
        {rows.map((shortcut) => {
          const cap = formatShortcutKey(shortcut);
          return (
            <Box component="li" key={cap} sx={rowSx}>
              <Typography variant="body1">{t(shortcut.label)}</Typography>
              <KeyCap>{cap}</KeyCap>
            </Box>
          );
        })}
      </Stack>
    </BaseDialog>
  );
}
